import { Component, EventEmitter, Input, OnChanges, Output, Renderer2, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { CountryDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

@Component({
  selector: 'app-country-combo-box',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './country-combo-box.component.html',
  styleUrls: ['./country-combo-box.component.scss']
})
export class CountryComboBoxComponent implements OnChanges {
  @Input() countryList: CountryDto[] | undefined;
  @Input() selectedCountry: CountryDto | undefined;
  /** Options: "up" | "down" | "smart" | undefined = "smart" */
  @Input() direction: string | undefined;
  @Output() valueChanged: EventEmitter<CountryDto> = new EventEmitter<CountryDto>();

  public isDropdownOpen: boolean;
  public isDropDownFocused: boolean;
  public selectedCountryName: string | undefined;

  constructor(private renderer: Renderer2) {
    this.isDropdownOpen = false;
    this.isDropDownFocused = false;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      let change = changes[propName];
      switch (propName) {
        case 'countryList': {
          this.updateSelected(this.selectedCountry);
          break;
        }
        case 'selectedCountry': {
          let selectedCountry = change.currentValue as unknown as CountryDto | undefined;
          this.updateSelected(selectedCountry);
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  private updateSelected(selectedCountry: CountryDto | undefined) {
    if (selectedCountry == undefined) {
      let operatorCountryCode = ENVIRONMENT.operatorCountryCode;
      if (operatorCountryCode == undefined || operatorCountryCode.length <= 0) {
        operatorCountryCode = 'DEU';
      }
      this.selectedCountry = this.countryList?.find(c => c.countryCode?.toUpperCase() == operatorCountryCode?.toUpperCase());
      this.selectedCountryName = this.selectedCountry?.country;
    } else {
      this.selectedCountryName = this.countryList?.find(c => c.dialingCode == selectedCountry?.dialingCode)?.country;
    }
    this.valueChanged.emit(this.selectedCountry);
  }

  public selectItem(value: CountryDto | undefined) {
    this.selectedCountryName = value?.country;
    this.isDropdownOpen = false;
    this.valueChanged.emit(value);
  }

  public toggleDropDown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;

    if (this.isDropdownOpen) {
      this.scrollToSelectedCountryOrTop();
      this.updateDirectionClass(event.target as HTMLElement);
    }

  }

  public scrollToSelectedCountryOrTop() {
    // timeout / delay required since the UI needs to update the document for the desired element to be available
    setTimeout(() => {
      let dialingCodeId = this.selectedCountry?.dialingCode;
      if (dialingCodeId == undefined || dialingCodeId.length <= 0) {
        return;
      }

      let element = document.getElementById(dialingCodeId);
      if (element != undefined) {
        element.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: 'start' });
      }
    }, 0);
  }

  public updateDirectionClass(target: HTMLElement) {
    // timeout / delay required since the UI needs to update the document for the desired element to be available
    setTimeout(() => {

      let dropDownMenu = this.renderer.nextSibling(target);
      if (dropDownMenu == undefined) {
        return;
      }

      // get the scollTop (distance scrolled from top)
      let scrollTop = target.getBoundingClientRect().height;
      // get the top offset of the dropdown (distance from top of the page)
      let topOffset = target.getBoundingClientRect().top;  //document.getElementsByClassName(".custom-dropdown")?.offset()?.top ?? 0;
      // calculate the dropdown offset relative to window position
      let relativeOffset = topOffset - scrollTop;
      // get the window height
      let windowHeight = window.innerHeight;

      switch (this.direction) {

        case "up":
          this.renderer.addClass(dropDownMenu, "reverse");
          break;

        case "down":
          // default / nothing
          break;

        case "smart":
          if (windowHeight == undefined || windowHeight <= 0) {
            return;
          }
          // if the relative offset is greater than half the window height,
          // reverse the dropdown.
          if (relativeOffset > windowHeight / 2) {
            this.renderer.addClass(dropDownMenu, "reverse");
          }
          else {
            this.renderer.removeClass(dropDownMenu, "reverse");
          }
          break;

        default:
          if (windowHeight == undefined || windowHeight <= 0) {
            return;
          }
          // if the relative offset is greater than half the window height,
          // reverse the dropdown.
          if (relativeOffset > windowHeight / 2) {
            this.renderer.addClass(dropDownMenu, "reverse");
          }
          else {
            this.renderer.removeClass(dropDownMenu, "reverse");
          }
          break;

      }

    }, 0);
  }
}
